import React from 'react';
import { Button, useWidth } from 'vindi-ds-components';
import styles from './styles';
import ScaffoldCard from './scaffold_card';
import CardLinks from './card_links';

function IncompleteCard({ linkTo, ButtonIcon, ...props }) {
  const { buttonLabel, isCompleted } = props;
  const mobile = ['xs', 'sm', 'md'].includes(useWidth());

  const Links = () => (
    <CardLinks mobile={mobile} {...props}>
      <Button href={linkTo} style={styles.buttonStyle} width={mobile ? '100%' : '208px'}>
        <ButtonIcon />
        {buttonLabel}
      </Button>
    </CardLinks>
  );
  return (
    <ScaffoldCard
      CardLinks={Links}
      iconColor='#999999'
      css={styles.incomplete}
      {...props}
      isCompleted={isCompleted}
    />
  );
}

export default IncompleteCard;
